import React, { FC, ReactNode, useState } from 'react';
import { AllieChevronDown } from '../../..';
import { AllieText } from '../../../components';
import {
  ButtonContainer,
  Card,
  DefaultContentContainer,
  ExpandButton,
  ExpandedContentContainer,
  HeaderContainer,
} from './ExpandablePanel.styles';

interface ExpandablePanelProps {
  header?: ReactNode;
  defaultContent?: ReactNode;
  expandedContent?: ReactNode;
  expandable?: boolean;
  expandedByDefault?: boolean;
  className?: string;
  labels: {
    expandBtnLabel: string;
    collapseBtnLabel: string;
  };
}

export const AllieExpandablePanel: FC<ExpandablePanelProps> = ({
  header,
  defaultContent,
  expandedContent,
  expandable = true,
  expandedByDefault = false,
  className,
  labels,
}) => {
  const [isExpanded, setIsExpanded] = useState(expandedByDefault);

  return (
    <Card className={className}>
      <HeaderContainer>{header}</HeaderContainer>
      <DefaultContentContainer>{defaultContent}</DefaultContentContainer>
      {expandedContent && isExpanded && (
        <ExpandedContentContainer>{expandedContent}</ExpandedContentContainer>
      )}
      {expandable && expandedContent && (
        <ExpandButton
          allieType="text"
          allieSize="small"
          corner="rounded-edges-plus"
          full
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <ButtonContainer>
            <AllieText type="field2" color="neutral-60">
              {isExpanded ? labels.collapseBtnLabel : labels.expandBtnLabel}
            </AllieText>
            <div
              style={{
                display: 'flex',
                transform: `scaleY(${isExpanded ? '-1' : '1'})`,
                color: 'var(--allie-color-neutral-60)',
              }}
            >
              <AllieChevronDown size={'xs'} display="flex" />
            </div>
          </ButtonContainer>
        </ExpandButton>
      )}
    </Card>
  );
};
